import React, { useState } from "react";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What are the objectives of this Software?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore omnis quaerat nostrum, pariatur ipsam sunt accusamus enim necessitatibus est fugiat."
    },
    {
      question: "What is the best features and services we deliver?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore omnis quaerat nostrum, pariatur ipsam sunt accusamus enim necessitatibus est fugiat."
    },
    {
      question: "Why is this Software important to me?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore omnis quaerat nostrum, pariatur ipsam sunt accusamus enim necessitatibus est fugiat."
    },
    {
      question: "How may I take part in and purchase this Software?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore omnis quaerat nostrum, pariatur ipsam sunt accusamus enim necessitatibus est fugiat."
    }
  ];

  return (
    <div>

      {/* ================= HERO SECTION ================= */}
      <section className="welcome_area faqs  ">
        <div className="container">
          <div className="row align-items-center">
             
            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">
                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge"> FAQ's</p>
                    </div>
                    <span className="integration-text">
                      Fast, flexible loans you can trust.
                    </span>
                  </div>
                </div>
                <h1 className="b-text bold">
                  Trusted loans made fast and flexible..
                </h1>
                <p>
                  Me Loans ensures a smooth borrowing experience with quick, flexible, and transparent loan options.
                </p>
                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="/contact-us" className="btn more-btn mr-3">
                    Contact us
                  </a>
                  <a className="btn more-btn" href="/apply-for-loan">
                     
                    Apply For Loan
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6"></div>
          </div>
        </div>
      </section>


      {/* ================= FAQ SECTION ================= */}
      <section className="faq-section py-5 bg-light">
        <div className="container">

          <div className="text-center mb-5">
            <h2 className="fw-bold">Frequently Asked Questions</h2>
            <p className="text-muted">
              Find answers to common questions about our services.
            </p>
          </div>

          <div className="row align-items-center justify-content-center">

            {/* IMAGE COLUMN */}
            <div className="col-lg-6 col-md-12 text-center mb-4 mb-lg-0">
              <img
                src="img/core-img/0faq.png"
                alt="FAQ"
                className="img-fluid"
              />
            </div>

            {/* FAQ COLUMN */}
            <div className="col-lg-6 col-md-12">

              {faqs.map((faq, index) => (
                <div key={index} className="mb-3">

                  <div
                    onClick={() => toggleFAQ(index)}
                    className="p-3 rounded text-white"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#05515a",
                      fontWeight: "500"
                    }}
                  >
                    {faq.question}
                  </div>

                  {activeIndex === index && (
                    <div className="p-3 border bg-white">
                      {faq.answer}
                    </div>
                  )}

                </div>
              ))}

            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Faqs;